<template>
    <div class="Progress" :style="`--percentage:${percentage};`">
        <span class="title" v-if="loading">
            {{ trans("Aan het laden") }}...
        </span>
        <span class="title" v-else>
            <span class="current">{{ seen }}</span>
            <span class="of">{{ trans("van") }}</span>
            <span class="total">{{ total }}</span>
            <span class="type" v-if="this.module_access">{{ trans(`multiple_${this.module_access}`)}}</span>
        </span>
    </div>
</template>

<script>

import { getQuery, setQuery } from "helpers/_structure";
import { defineComponent, computed, reactive, watch, onMounted } from "vue";
import trans from "helpers/_translation";

export default defineComponent({
	name: "Progress",
	props: {
        module_access: {
            type: String,
            required: false,
            default: null
        },
		pagination_total: {
			type: [Number, String],
			required: false
		},
		pagination_limit: {
			type: [Number, String],
			required: false
		},
		pagination_current: { // Almost never used only for loading specific page by default
			type: [Number, String],
			required: false,
			default: 1
		},
        loading: {
            type: Boolean,
            required: false,
            default: false
        }
	},
	setup(props, { emit } ) {

        const total = computed(() => (typeof props.pagination_total === "number") ? Number(props.pagination_total) : 0);
		const limit = computed(() => Number(props.pagination_limit));
		const pages = computed(() => Math.ceil(total.value / limit.value));

        const seen = computed(() => Math.min(limit.value * props.pagination_current, total.value));
        const percentage = computed(() => `${Math.min(100, Math.round(seen.value / total.value * 100))}%`);
        const loading = computed(() => props.loading);

		return {
			pages,
			total,
			limit,

            seen,
            percentage,
            loading,

			trans
		}
	},
});
</script>